"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
var vue_1 = require("vue");
var _hoisted_1 = { class: "vue-accordion-body" };
function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (vue_1.openBlock(), vue_1.createElementBlock("div", {
        class: vue_1.normalizeClass(["vue-accordion", { 'toggled': !$data.toggled }])
    }, [
        vue_1.createElementVNode("div", {
            class: "vue-accordion-toggler",
            onClick: _cache[0] || (_cache[0] =
                //@ts-ignore
                function () {
                    var args = [];
                    for (var _i = 0; _i < arguments.length; _i++) {
                        args[_i] = arguments[_i];
                    }
                    return ($options.toggle && $options.toggle.apply($options, args));
                })
        }, [
            vue_1.renderSlot(_ctx.$slots, "toggler")
        ]),
        vue_1.withDirectives(vue_1.createElementVNode("div", _hoisted_1, [
            vue_1.renderSlot(_ctx.$slots, "default")
        ], 512), [
            [vue_1.vShow, $data.toggled]
        ])
    ], 2));
}
exports.render = render;
